import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { IKnowledge } from '@web-nx-ng-tsc/web-shared-data-access';
import { ReplaceBucket } from '@web-nx-ng-tsc/util-func';

@Component({
  selector: 'lib-web-shared-ui-knowledge-card',
  standalone: true,
  imports: [],
  templateUrl: './lib-knowledge-card.component.html',
  styleUrl: './lib-knowledge-card.component.scss',
})
export class LibKnowledgeCardComponent {
  // Decorator for the data of the card
  @Input() set data(value: IKnowledge) {
    this.dataSignal.set(value);
  }

  @Input() headingLevel: 'h2' | 'h3' = 'h2';
  // Decorator for the output event emitter
  @Output() emitVideoLinkUrl = new EventEmitter();

  public readonly replaceBucket = new ReplaceBucket();

  dataSignal = signal<IKnowledge>({
    img: '',
    title: '',
    excerpt: '',
    link_url: '',
    isVideo: false,
  });

  // Method to emit the link_url of the Video
  onClickVideoLinkUrl(link_url: string) {
    this.emitVideoLinkUrl.emit(link_url);
  }
}
